import React from 'react';
import { AlertCircle, XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-white" data-id="element-226">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        <div className="text-center mb-16" data-id="element-228">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-brand-dark mb-6" data-id="element-229">
            ¿Te reconoces en esta situación?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-230">
            Mírate al espejo por un segundo. ¿Reconoces ese cansancio en tus
            ojos?
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-231">
          {[{
          title: 'Hinchazón Crónica',
          desc: 'Esa sensación de pesadez que empieza a las 3 de la tarde y hace que tu pantalón favorito se sienta como una tortura.'
        }, {
          title: 'Cansancio Inexplicable',
          desc: 'Te levantas cansada aunque hayas dormido. Necesitas café para arrancar y azúcar para seguir.'
        }, {
          title: 'Metabolismo Lento',
          desc: 'Sientes que engordas solo con mirar la comida, mientras que antes podías comer lo que quisieras.'
        }].map((item, i) => <div key={i} className="bg-brand-cream p-6 rounded-xl border border-brand-light" data-id="element-232">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-4 text-red-600" data-id="element-233">
                <XCircle className="h-6 w-6" data-id="element-234" />
              </div>
              <h3 className="font-serif text-xl font-bold text-brand-dark mb-3" data-id="element-235">
                {item.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-236">{item.desc}</p>
            </div>)}
        </div>

        <div className="bg-brand-light/50 p-8 md:p-12 rounded-2xl border-l-4 border-brand-gold" data-id="element-237">
          <div className="flex items-start" data-id="element-238">
            <AlertCircle className="h-8 w-8 text-brand-gold mr-4 flex-shrink-0 mt-1" data-id="element-239" />
            <div data-id="element-240">
              <h3 className="text-2xl font-serif font-bold text-brand-dark mb-4" data-id="element-241">
                No es que estés comiendo "mal". No es falta de ejercicio.
              </h3>
              <p className="text-lg text-gray-700 mb-4" data-id="element-242">
                Es que tu cuerpo está atrapado en un ciclo de{' '}
                <strong className="text-brand-dark" data-id="element-243">inflamación crónica</strong>
                .
              </p>
              <p className="text-lg text-gray-700 mb-4" data-id="element-244">
                Después de los 40, tu motor digestivo cambia. Las enzimas
                disminuyen, el cortisol sube y lo que antes te sentaba bien,
                ahora te hincha. Estás luchando una batalla química que no
                puedes ganar con fuerza de voluntad.
              </p>
              <p className="text-xl font-bold text-brand-dark italic" data-id="element-245">
                "El cuerpo no quema grasa en un estado de emergencia."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}